<script lang="ts" setup>
import type { ChildElement } from '~~/server/api/faq/index'

export interface FaqListChildrenProps {
    children: ChildElement[]
}

const props = defineProps<FaqListChildrenProps>()
</script>

<template>
  <ul>
    <li
      v-for="(link, index) in props.children"
      :key="`faqcl-${index}`"
    >
      <VNuxtLink
        :to="{
          name: 'faq-category',
          params: {
            id: link.slug,
          },
        }"
        class="fs-md-bigger d-flex align-items-center mb-4"
        :label="link.title"
      >
        {{ link.title }}
        <slot name="icon" />
      </VNuxtLink>
    </li>
  </ul>
</template>
